import {
    Checkbox, DefaultButton, Dropdown, getId, Icon, IDropdownOption, Modal,
    PrimaryButton, ProgressIndicator, TextField
} from "@fluentui/react";
import {
    checkboxStyles,
    defaultButtonStyles, dropdownStyles, primaryButtonStyles, textFieldStyles
} from "../../../common/views/DefaultStyles";
import ModalHeaderView from "../../../common/views/ModalHeaderView";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { AddressModel } from "../../models/AddressModel";

export type AddressEntryProps = {
    isEdit: boolean;
    form: AddressModel;
    errorMessages: any;
    states: IDropdownOption[];
    submitting: boolean;
    onValueChange: (field: keyof AddressModel, value: any) => void;
    onSubmit: () => void;
    onClose: () => void;
}

export default function AddressEntryProps({
    isEdit, form, errorMessages, states, submitting, onValueChange, onSubmit, onClose
}: AddressEntryProps) {
    const isMobile = window.innerWidth <= 500;
    const width6 = Utils.getColumnWidth(6);
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const address1Input = () => {
        return <>
            <TextField
                label="Address 1"
                value={form.address1}
                onChange={(_, v) => onValueChange("address1", v || "")}
                errorMessage={errorMessages.address1}
                styles={textFieldStyles} />
        </>;
    }

    const address2Input = () => {
        return <>
            <TextField
                label="Address 2"
                value={form.address2}
                onChange={(_, v) => onValueChange("address2", v || "")}
                errorMessage={errorMessages.address2}
                styles={textFieldStyles} />
        </>;
    }

    const statePicker = () => {
        return <>
            <Dropdown
                label="City / Province"
                selectedKey={form.stateId}
                options={states}
                styles={dropdownStyles}
                onChange={(_, v) => onValueChange("stateId", v?.key || 0)} />
        </>;
    }

    const isPrimaryCheckbox = () => {
        return <>
            <Checkbox
                label="Set Default?"
                checked={form.isPrimary}
                onChange={(_, v) => onValueChange("isPrimary", v || false)}
                styles={checkboxStyles}
            />
        </>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row">
            <div className={width6}>
                <DefaultButton
                    onClick={onClose}
                    styles={defaultButtonStyles}
                >Cancel</DefaultButton>
            </div>
            <div className={width6 + " right"}>
                <PrimaryButton
                    onClick={onSubmit}
                    styles={primaryButtonStyles}
                >Submit</PrimaryButton>
            </div>
        </div>;
    }

    const modalHeader = () => {
        const title = isEdit ? "Edit Address: " + form.id : "Add New Address";

        return <>
            <ModalHeaderView title={title} onClose={onClose} />
        </>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            {modalHeader()}

            <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body ph-15"}>
                <div className="pt-15">{address1Input()}</div>
                <div className="pt-15">{address2Input()}</div>
                <div className="pt-15">{statePicker()}</div>
                <div className="pt-15">{isPrimaryCheckbox()}</div>

                {!submitting && <div className="pv-20">{buttons()}</div>}

                {submitting && <div className="pv-20">
                    <ProgressIndicator label="Submitting" description="" />
                </div>}
            </div>
        </Modal>
    </>;
}